var $ = require('../modules/jquery');
var _throttle = require('lodash/throttle');

(function () {
  var $window = $(window);

  // Duration of the scrolling animation (in ms)
  var scroll_duration = 700;

  // Ammount of time to give elements to load after page load (in ms)
  var element_load_buffer = 500;

  // Handle links to a page section coming from other pages
  var _blockScrollOnLoad = function() {
    window.scrollTo(0, 0);
  };
  
  var _determineHashTarget = function(hash) {
    var withoutHashSign = (hash).toString().replace(/^\#/,'');
    // html5 first then whatever goes.
    return $('#'+withoutHashSign+", [data-section-name='"+withoutHashSign+"'], [name='"+withoutHashSign+"']").first();
  };

  if (
       window.location.hash 
      // don't mess with things if not necessary
      && $(_determineHashTarget(window.location.hash)).length > 0
    ) {
    // Temporarily disable scrolling to block the browser's default scroll to
    // element behavior
    $window
      .on('scroll', _blockScrollOnLoad)
      .on('load', function() {
        setTimeout(function() {
          var $hashSection = _determineHashTarget(window.location.hash);
          var containerMargin = parseInt(
            $('#content-container').css('marginTop')
          );
          var targetTop = $hashSection.offset().top - containerMargin;

          // Restore scrolling
          $window.unbind('scroll', _blockScrollOnLoad);

          // Scroll to section
          $('html, body').animate(
            {scrollTop: targetTop},
            scroll_duration,
            function() {
              // Focus section so that keyboard navigation starts at that scection
              $hashSection.focus();
            }
         );
         }, element_load_buffer);
      });
  }

  // Back to top link
  var $shortcut = $('#shortcut--header');

  // Browser window scroll (in pixels) after which the "back to top" link is shown
  var offset = 300;

  // Hide or show the shortcut (only applies to "back to top" link)
  var _throttledScrollToTopCheck = _throttle(function () {
    if ($window.scrollTop() > offset) {
      $shortcut.addClass('shortcut--visible');
    } else {
      $shortcut.removeClass('shortcut--visible shortcut--fade-out');
    }
  }, 100);

  $window.on('scroll',_throttledScrollToTopCheck);

  $(document).ready(function () {
    _throttledScrollToTopCheck();

    // Smooth scroll to shortcut destination
    $('body').on('click', 'a[class^="shortcut--"], #content-container a[href^="#"]', function (e) {
      var containerMargin = $('#content-container').css('marginTop');
      containerMargin = parseInt(containerMargin);
      var target = this.hash;
      var $target = $(target);

      // if this is the header shortcut, we'll manually jump to the top
      var offset = (target === '#header-container') ? 0 : $target.offset().top - containerMargin;

      // animate scroll to the destination
      $('html, body')
        .stop()
        .animate({'scrollTop': offset}, scroll_duration, 'swing');
    });

    // Form validation scrolling to account for sticky header
    $('input').on('invalid', function(e) {
      var first = $('form').find(':invalid').first();
      var headerHeight = $('#header-container').outerHeight();
      var formblockLabel = $('.formblock__label').outerHeight(true);

      $('html, body').animate({
        scrollTop: $(first).offset().top - (headerHeight + formblockLabel)
      }, 0);
    });

  });
})();



//////////////////
// WEBPACK FOOTER
// ./web/themes/contrib/nccourts-theme/assets/src/js/components/shortcuts.js
// module id = 49
// module chunks = 9